<template>
  <div class="card card-top-line">
    <!-- Header -->
    <div class="header d-flex justify-content-between align-items-center">
      <h2>Cards</h2>
    </div>
    <div class="body">
      <div class="chart-top-action d-lg-flex justify-content-between py-3">
        <div class="mr-0 mr-md-3 action-top-search">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search Card"
              aria-label="Search"
              v-model="searchText"
              aria-describedby="search-transactions"
              v-on:keyup.enter="getBeneficiaryList"
            />
            <div class="input-group-append" @click="'#'">
              <span class="input-group-text" id="search-mail">
                <i class="icon-magnifier"></i>
              </span>
            </div>
          </div>
        </div>
        <!-- Table Pagination -->
        <div class="d-flex mt-auto table-pagination">
          <div class="number-page">
            <b-pagination
              class="pagination-small"
              v-model="currentPage"
              :total-rows="totalRows"
              first-text="First"
              last-text="Last"
              :per-page="perPage"
              align="right"
            ></b-pagination>
          </div>
        </div>
      </div>
      <b-table
        responsive
        outlined
        table-class="mb-0 table-custom"
        head-variant="light"
        :items="cardList"
        :fields="cardListfields"
        :emptyText="'No data found.'"
        show-empty
        striped
      >
        <template #cell(card_number)="data">
          <a href="javascript:void(0);" @click="editAccounts(data.item)">
            {{ data.value }}
          </a>
        </template>
        <template #cell(card_brand)="data">
          <img
            width="40px"
            :src="data.value.img"
            v-b-tooltip.hover
            :title="data.value.name"
          />
        </template>
        <template #cell(block_status)="data">
          {{ data.value }}
          <select
            class="btn btn-filter badge badge-primary btn-sm"
            v-model="data.value"
          >
            <option value="">Select Option</option>
            <option
              v-for="(option, index) in blockStatuses"
              :key="index"
              :value="option"
            >
              {{ option.value }}
            </option>
          </select>
        </template>
      </b-table>
      <!-- Table Pagination -->
      <div
        class="d-flex py-3 align-items-center justify-content-between table-pagination"
      >
        <div class="per-page">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="number-page">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            first-text="First"
            last-text="Last"
            :per-page="perPage"
            align="right"
          ></b-pagination>
        </div>
        <div class="go-page">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">Go To Page</span>
            </div>
            <input
              type="text"
              v-model="currentPageJump"
              class="form-control"
              value=""
              @keyup.enter="onEnter"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AllCards",
  components: {
    //
  },
  data() {
    return {
      cardList: [
        {
          name: "MasterCard",
          card_brand: {
            name: "Master-Card",
            img: require(`@/assets/ecommerce/card-master.png`),
          },
          type: "Credit",
          card_number: ".... .... .... 1548",
        },
        {
          name: "Visa",
          card_brand: {
            name: "Visa",
            img: require(`@/assets/ecommerce/card-visa.png`),
          },
          type: "Debit",
          card_number: ".... .... .... 7548",
        },
        {
          name: "Visa",
          card_brand: {
            name: "Visa",
            img: require(`@/assets/ecommerce/card-visa.png`),
          },
          type: "Credit",
          card_number: ".... .... .... 6478",
        },
        {
          name: "Amex",
          card_brand: {
            name: "Amex",
            img: require(`@/assets/ecommerce/card-amex.png`),
          },
          type: "Debit",
          card_number: ".... .... .... 8948",
        },
      ],
      searchText: "",

      cardListfields: [
        { key: "card_number", label: "Card Number", thClass: "th_sortfix" },
        { key: "card_brand", label: "Card Brand", thClass: "th_sortfix" },
        { key: "type", label: "Type", thClass: "th_sortfix" },
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],
      blockStatuses: [
        { value: "Monitor" },
        { value: "Restricted" },
        { value: "Suspended" },
        { value: "Terminated" },
        { value: "Blacklisted" },
        { value: "Approved" },
      ],
      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: true,
    };
  },
  methods: {
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
    editAccounts(data) {
      let params = {};
      params.name = "Card";
      params.value = data.card_number;
      this.$router.push({
        path: "/accounts/edit",
        query: {
          name: this.$CryptoJS.AES.encrypt(params.name, "name").toString(),
          value: this.$CryptoJS.AES.encrypt(params.value, "value").toString(),
        },
      });
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      this.$toast.success(`${type} Copied`, { position: "top-right" });
    },
  },
  watch: {
    //
  },
};
</script>
